import { useEffect, useContext } from 'react';
import { CopilotChannelContext } from '../CopilotChannelContext';
import { consoleIfNotProd } from 'chatspot-core/loggers/consoleIfNotProd';
export function useSubscribeToCopilotChannel(topic, onTopic) {
  const {
    channel
  } = useContext(CopilotChannelContext);
  useEffect(() => {
    if (!channel) {
      consoleIfNotProd.error(`Channel not found.  Are you trying to subscribe to the copilot channel outside of <CopilotProvider/>?`);
      return () => {};
    }
    const unsubscribe = channel.subscribe(topic, onTopic);
    return () => {
      unsubscribe();
    };
  }, [channel, onTopic, topic]);
}